module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/incredLogo.00c09933.png";